export default function Star(props: {isHalf?: boolean}) {
  return !props.isHalf ? (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 17.0901V4L9.47823 9.40999L3.5 10.1117L7.92018 14.1566L6.74717 20L12 17.0901Z"
        fill="#19647E"
      />
      <path
        d="M12 17.0901V4L14.5218 9.40999L20.5 10.1117L16.0798 14.1566L17.2528 20L12 17.0901Z"
        fill="#19647E"
      />
    </svg>
  ) : (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 17.0901V4L9.47823 9.40999L3.5 10.1117L7.92018 14.1566L6.74717 20L12 17.0901Z"
        fill="#19647E"
      />
      <path
        d="M12 17.0901V4L14.5218 9.40999L20.5 10.1117L16.0798 14.1566L17.2528 20L12 17.0901Z"
        fill="#EAEEF5"
      />
    </svg>
  )
}
